import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loader } from '../../components/atoms/Loader';

export const NavigatorSupport: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(-1);
  }, []);

  return (
    <Loader />
  );
};